import loadable from '@loadable/component';
import { Redirect, Route, Switch } from 'react-router';
import Layout from './components/Layout';
const Landing = loadable(() => import('./pages/Landing'))
const Home = loadable(() => import('./pages/Home'))
const Transaction = loadable(() => import('./pages/transaction'))
const Invoice = loadable(() => import('./pages/invoice'))
const InvoiceDetail = loadable(() => import('./pages/invoice/detail'))
const DreamBook = loadable(() => import('./pages/dream'))
const BetDetail = loadable(() => import('./pages/BetDetail'));
const MarketResultHistory = loadable(() => import('./pages/MarketResultHistory'));
// const Auth = loadable(() => import('./pages/Auth'))
// import Home from "./pages/Home";
// import Play from "./pages/Play";
// import Transaction from "./pages/Transaction";
// import Auth from "./pages/Auth";
import AuthStore from './store/Auth';

import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { library } from '@fortawesome/fontawesome-svg-core';
import './assets/bootstrap.scss';
import NumpadProvider from './components/Numpad';
import './components/Numpad.css';
// import Play from "./pages/games/v2/Play";
import { fab } from '@fortawesome/free-brands-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { useEffect, useState } from 'react';
import PlayStore from './store/Play';
library.add(fab, fas);

export default connect(
  (state) => ({ auth: state.auth, play: state.play }),
  { ...AuthStore.actionCreators, ...PlayStore.actionCreators }
)(({ auth, play, ...props }) => {

  // useEffect(() => {
  //   if (auth.needRefresh && !auth.isLoading) {
  //     props.refresh()
  //   }
  // }, [auth.needRefresh])

  useEffect(() => {
    if (auth.isLoading)
      return;

    if (auth.needRefresh) {
      props.refresh()
    }
    else if (!auth.isAuthenticated) {
      const token = auth.token;
      const currency = play.currency;
      if (token) {
        props.authenticate(token, currency).catch(e => {

        });
      }
    }
  }, [auth.token, play.currency, auth.needRefresh, auth.isLoading, auth.isAuthenticated])


  useEffect(() => {
    if (auth.isAuthenticated) {
      props.requestPlayVersion()
      props.requestAgentGameSettings(true)
      props.requestBalance()
    }
  }, [auth.isAuthenticated])

  const [Play, setPlay] = useState(Landing)

  useEffect(() => {
    if (play.version) {
      setPlay(loadable(() => import(`./pages/games/${play.version}/Play`)))
    }
  }, [play.version])

  return (
  <Layout>
    <Switch>
      <Route path="/bet/*" component={BetDetail} />

      {auth.isAuthenticated && play.version && (
        <>
          <Route exact path="/">
            <Redirect to="/play" />
          </Route>
          <Route path="/play/:market?/:game?/:variant?">
              <NumpadProvider>
                <Play/>
              </NumpadProvider>
            </Route>
          <Route path="/transaction" component={Transaction} />
          <Route exact path="/invoice" component={Invoice} />
          <Route path="/invoice/*" component={InvoiceDetail} />
          <Route path="/bukumimpi" component={DreamBook} />
          <Route path="/results/:market?" component={MarketResultHistory} />
        </>
      ) ||(
        <Route exact path="/" component={Landing} />
      )}

      {!auth.isAuthenticated && !auth.isLoading && play.version && (
        <Redirect to="/" />
      )}

      <Route path="*" component={Landing} />
    </Switch>

    <ToastContainer
      position="top-right"
      autoClose={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
    />
  </Layout>
);

})